module.exports = __webpack_public_path__ + "img/service_img6.aab8d4a5.png";